import { createStyles, Theme } from '@material-ui/core'
import { RichTextEditorProps } from './richTextEditor.model'

export const richTextEditorStyle = (theme: Theme) =>
  createStyles({
    quillEditor: {
      width: '100%',
      minHeight: '200px',
      height: '100%'
    },
    container: {
      height: (props: RichTextEditorProps) => props.height || '350px',
      paddingBottom: theme.spacing(3),
      marginBottom: theme.spacing(2),
      flexGrow: 1
    }
  })
